import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContextualEmbedErrorState = ({
  onRetry
}) => {
  return /*#__PURE__*/_jsxs(UIFlex, {
    "data-test-id": "contextual-embed-error-state",
    className: "m-top-8",
    direction: "column",
    align: "center",
    children: [/*#__PURE__*/_jsx("div", {
      className: "m-bottom-4",
      children: /*#__PURE__*/_jsx(UIIllustration, {
        width: 200,
        name: "errors/general"
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "fatalErrors.errorLoadingWorkflow.embed.message"
    }), /*#__PURE__*/_jsx(UIButton, {
      className: "m-all-4",
      use: "tertiary-light",
      onClick: onRetry,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "fatalErrors.errors.retryButton"
      })
    })]
  });
};
export default ContextualEmbedErrorState;